export const errorFilters: { [key: number]: string[] } = {
  412: [
    $localize`:@@api_errors.payment_option.wrong_credentials:Wrong credentials`,
    'Santander DE API error: POS Santander DE API Error: Der Login ist nicht korrekt.',
  ],
};
